import React from 'react';
import { 
  HelpCircle, 
  Home, 
  FileText, 
  Clock, 
  Award, 
  Bookmark, 
  Calculator, 
  HelpingHand 
} from 'lucide-react';

const TaxInfoSidebar = () => {
  const taxInfo = [
    {
      icon: Home,
      title: 'Объекты налогообложения',
      description: 'Жилые дома, квартиры, комнаты, гаражи, машино-места, единые недвижимые комплексы и другие строения.'
    },
    {
      icon: FileText,
      title: 'Налоговая база',
      description: 'Кадастровая стоимость, указанная в ЕГРН или определенная в установленном порядке.'
    },
    {
      icon: Clock,
      title: 'Сроки уплаты',
      description: 'Налог необходимо уплатить не позднее 1 декабря года, следующего за истекшим налоговым периодом.'
    },
    {
      icon: Award,
      title: 'Льготы',
      description: 'Пенсионеры, инвалиды I и II групп, ветераны боевых действий и другие категории граждан имеют право на льготы.'
    },
    {
      icon: Bookmark,
      title: 'Налоговые вычеты',
      description: 'Уменьшение налоговой базы на площадь: 20 кв.м. для квартир, 10 кв.м. для комнат, 50 кв.м. для домов.'
    },
    {
      icon: Calculator,
      title: 'Налоговые ставки',
      description: 'Устанавливаются муниципальными образованиями, но не могут превышать пределы, установленные федеральным законом.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        О налоге на имущество
      </h3>

      <div className="space-y-3">
        {taxInfo.map((info, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <info.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {info.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {info.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpingHand className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Нужна помощь с налогами?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Получите консультацию специалиста по вопросам налогообложения или составьте налоговую декларацию с профессиональной поддержкой.
            </p>
            <a 
              href="https://www.nalog.gov.ru/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors inline-block text-center"
            >
              Сайт ФНС России
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxInfoSidebar;